import { ArrowLeft, Eye, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AdminSurveys } from "@/components/vomarc/AdminSurveys";
import { AdminVault } from "@/components/vomarc/AdminVault";
import { AdminControls } from "@/components/vomarc/AdminControls";
import { AdminLogin } from "@/components/vomarc/AdminLogin";
import { FoundersPanel, ImagesPanel, LinksPanel, WebsiteEditorPanel } from "@/components/vomarc/AdminSettingsPanels";
import { AppStatesPanel, EnquiriesPanel } from "@/components/vomarc/AdminEnquiries";
import { useAdminSession } from "@/components/vomarc/useAdminSession";

export function AdminPage() {
  const s = useAdminSession();

  if (!s.token) return <AdminLogin onLogin={s.login} />;

  const panelProps = { settings: s.settings, update: s.update, saveSettings: s.saveSettings, uploadImage: s.uploadImage };

  return (
    <main className="admin-page" data-testid="admin-dashboard-page">
      <section className="admin-shell" data-testid="admin-dashboard-shell">
        <div className="admin-topbar" data-testid="admin-topbar">
          <div>
            <span className="eyebrow">Private administration</span>
            <h1>VOMARC Control Dashboard</h1>
          </div>
          <div className="admin-actions">
            <a className="ghost-cta-dark" href="/" data-testid="admin-back-button"><ArrowLeft size={16} /> Back to website</a>
            <Button className="ghost-cta-dark" onClick={() => s.loadSummary()} disabled={s.loading} data-testid="admin-refresh-button"><Eye size={16} /> {s.loading ? "Loading…" : "Refresh"}</Button>
            <Button className="text-cta-dark" onClick={s.logout} data-testid="admin-logout-button"><LogOut size={16} /> Logout</Button>
          </div>
        </div>

        <div className="admin-grid">
          <WebsiteEditorPanel {...panelProps} />
          <FoundersPanel {...panelProps} />
          <AdminControls settings={s.settings} update={s.update} saveSettings={s.saveSettings} authHeaders={s.authHeaders} reload={s.loadSummary} />
          <LinksPanel {...panelProps} />
          <ImagesPanel {...panelProps} />
          <EnquiriesPanel demoRequests={s.demoRequests} investorRequests={s.investorRequests} updateStatus={s.updateStatus} deleteEnquiry={s.deleteEnquiry} />
          <AdminSurveys authHeaders={s.authHeaders} />
          <AdminVault authHeaders={s.authHeaders} />
          <AppStatesPanel appStates={s.appStates} />
        </div>
      </section>
    </main>
  );
}
